import styled from '@emotion/styled';
import theme from '../../constants/theme';

type ButtonProps = {
  fontSize?: string;
  fontWeight?: string;
  color?: string;
  bgColor?: string;
  width?: string;
  theme?: typeof theme;
  border?: string;
  variant?: 'ghost';
};

const Button = styled.button<ButtonProps>`
  font-size: ${(props) => (props.fontSize ? `${props.fontSize}` : '16px')};
  background-color: ${(props) => {
    if (props.variant === 'ghost') return 'transparent';
    return props.bgColor ? props.bgColor : '#232323';
  }};
  padding: ${(props) => (props.variant === 'ghost' ? '0' : '10px 30px')};
  color: ${(props) => (props.color ? props.color : props.theme.colors.white)};
  border-radius: 4px;
  cursor: pointer;
  border: ${(props) => {
    if (props.variant === 'ghost') return 'none';
    return props.border ? `${props.border}` : 'none';
  }};
  outline: none;
  transition: all 0.1s linear;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  width: ${(props) => (props.width ? `${props.width}` : 'auto')};
  font-weight: ${(props) => (props.fontWeight ? `${props.fontWeight}` : '400')};
  &:hover {
    opacity: 0.95;
  }

  &:active {
    transform: scale(0.95);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export default Button;
